export default __webpack_public_path__ + "static/media/HoverIcon.c565dcc1.svg";